import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { toast } from 'sonner'
import { AppHeader } from '#/components/layout/app-header'
import { Button } from '#/components/ui/button'
import { Textarea } from '#/components/ui/textarea'
import { api } from '#/lib/api'
import { cn } from '#/lib/utils'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/feedback')({ component: Feedback })

function Feedback() {
  const navigate = useNavigate()
  const [rating, setRating] = useState(0)
  const [message, setMessage] = useState('')
  const submit = async () => {
    await api('/api/feedback/submit', { method: 'POST', json: { context: 'workspace-generated', rating: rating || undefined, message } }).catch(() => {})
    toast.success(m.feedback_thanks())
    navigate({ to: '/home' })
  }
  return (
    <>
      <AppHeader />
      <main className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-md space-y-4 rounded-2xl border bg-card p-6">
          <h1 className="text-2xl font-bold">{m.feedback_title()}</h1>
          <div className="space-y-2"><p className="text-sm">{m.feedback_rating()}</p><div className="flex gap-2">{[1, 2, 3, 4, 5].map((n) => <button key={n} className={cn('size-10 rounded-full border text-sm', rating === n && 'border-primary bg-primary text-primary-foreground')} onClick={() => setRating(n)}>{n}</button>)}</div></div>
          <div className="space-y-2"><p className="text-sm">{m.feedback_message()}</p><Textarea rows={4} value={message} onChange={(e) => setMessage(e.target.value)} /></div>
          <Button onClick={submit} disabled={!rating && !message.trim()}>{m.feedback_submit()}</Button>
        </div>
      </main>
    </>
  )
}
